import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import "./AdminMenu.scss";

export default function AdminMenu() {
  const adminMenuLinks = [
    {
      linkTo: "branches",
      FormattedMessageId: "admin_menu_branches",
      FormattedMessageDefaultMessage: "Filiales",
    },
    {
      linkTo: "regions",
      FormattedMessageId: "admin_menu_regions",
      FormattedMessageDefaultMessage: "Régions",
    },
    {
      linkTo: "countries",
      FormattedMessageId: "admin_menu_countries",
      FormattedMessageDefaultMessage: "Pays",
    },
    {
      linkTo: "currency",
      FormattedMessageId: "admin_menu_currency",
      FormattedMessageDefaultMessage: "Devise",
    },
    {
      linkTo: "exchange-rate",
      FormattedMessageId: "admin_menu_exchange_rate",
      FormattedMessageDefaultMessage: "Taux de change",
    },
    {
      linkTo: "profile",
      FormattedMessageId: "admin_menu_profile",
      FormattedMessageDefaultMessage: "Profile",
    },
    {
      linkTo: "reasonleave",
      FormattedMessageId: "admin_menu_reasonleave",
      FormattedMessageDefaultMessage: "Motifs de sortie",
    },
    {
      linkTo: "typecompanies",
      FormattedMessageId: "admin_menu_typecompanies",
      FormattedMessageDefaultMessage: "Type de sociétés",
    },
    {
      linkTo: "recruitmentmethods",
      FormattedMessageId: "admin_menu_recruitmentmethods",
      FormattedMessageDefaultMessage: "Mode de recutement",
    },
    {
      linkTo: "sector",
      FormattedMessageId: "admin_menu_sector",
      FormattedMessageDefaultMessage: "Secteur",
    },
    {
      linkTo: "syntec",
      FormattedMessageId: "admin_menu_syntec",
      FormattedMessageDefaultMessage: "Syntec",
    },
    {
      linkTo: "syntecposcoef",
      FormattedMessageId: "admin_menu_syntecposcoef",
      FormattedMessageDefaultMessage: "Coefficient & Position Consultant",
    },
    {
      linkTo: "syntecposcoef-staff",
      FormattedMessageId: "admin_menu_syntecposcoef_staff",
      FormattedMessageDefaultMessage: "Coefficient & Position Staff",
    },
    {
      linkTo: "jobs",
      FormattedMessageId: "admin_menu_jobs",
      FormattedMessageDefaultMessage: "Métiers",
    },
    {
      linkTo: "job-categories",
      FormattedMessageId: "admin_menu_job_categories",
      FormattedMessageDefaultMessage: "Catégories de métiers",
    },
    {
      linkTo: "appeal",
      FormattedMessageId: "admin_menu_recoursestr",
      FormattedMessageDefaultMessage: "Recours Str",
    },
    {
      linkTo: "ttv",
      FormattedMessageId: "admin_menu_ttv",
      FormattedMessageDefaultMessage: "TTV",
    },
    {
      linkTo: "manager-backup",
      FormattedMessageId: "admin_menu_manager_backup",
      FormattedMessageDefaultMessage: "Manager Backup",
    },
    {
      linkTo: "document",
      FormattedMessageId: "admin_menu_document",
      FormattedMessageDefaultMessage: "Document",
    },
  ];
  return (
    <div className="style-menu-row">
      {adminMenuLinks.map((link) => {
        return (
          <div className="style-item-menu" key={link.linkTo}>
            <Link to={link.linkTo}>
              <FormattedMessage
                id={link.FormattedMessageId}
                defaultMessage={link.FormattedMessageDefaultMessage}
              />
            </Link>
          </div>
        );
      })}
    </div>
  );
}
